<template>
  <component :is="tag" v-bind="linkAttrs" class="stat-card text-decoration-none"
    :class="{ 'stat-card-attention': attention }">
    <span class="text-label">{{ label }}</span>
    <span class="stat-value">
      <slot>{{ value }}</slot>
      <span v-if="suffix" class="stat-suffix"> {{ suffix }}</span>
    </span>
    <div v-if="progress !== null" class="progress progress-thin" role="progressbar" :aria-label="label"
      :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar bg-primary" :style="{ width: progress + '%' }"></div>
    </div>
    <span v-if="hint" class="small" :class="attention ? '' : 'text-body-secondary'">{{ hint }}</span>
  </component>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], default: "" },
  suffix: { type: String, default: "" },
  hint: { type: String, default: "" },
  // 0–100; null hides the bar
  progress: { type: Number, default: null },
  attention: { type: Boolean, default: false },
  // router target or external URL; makes the whole card a link
  to: { type: [String, Object], default: null },
  href: { type: String, default: null },
});

const tag = computed(() => {
  if (props.to) return "router-link";
  if (props.href) return "a";
  return "div";
});

const linkAttrs = computed(() => {
  if (props.to) return { to: props.to };
  if (props.href) return { href: props.href, target: "_blank", rel: "noopener" };
  return {};
});
</script>
